<template>
  <div class="employee-auction__header" v-if="Object.keys(currentAuctionsCatalog).length">
    <AuctionHouseDetails
      :auctionsCatalog="currentAuctionsCatalog"
      :auctionHouse="currentAuctionsCatalog.auctionHouse"
      :address="currentAuctionsCatalog.address"
    />
    <div class="mt-3">
      {{I18n.t(`employees.results.auctions_catalogs.status.${auctionsCatalog.status}`)}}
      <ToggleButton
        v-show="statusNoLack"
        :value="toggle"
        :sync="true"
        color="#7FCAC3"
        @change="makeToggle" />
    </div>
    <div class="employee-tabs tabs mb-0">
      <ul>
        <li>
          <router-link :to="{ name: 'employeesFinishedAuctionsCatalogArtworks' }">
            {{I18n.t('employees.auctions_catalogs.catalog')}}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  /* global Routes */
  import { mapGetters, mapActions } from 'vuex';
  import { compareAuctionStatus } from '@/shared/helpers';
  import AuctionHouseDetails from './../../auction_house_details';
  import { STATUS_VALUES,
    PUBLISHED,
    UNPUBLISHED,
    CATALOG_LIVE_TYPE,
    LACK } from './../../../consts';

  export default {
    name: 'InternetAuctionsCatalogHeader',
    components: {
      AuctionHouseDetails,
    },
    computed: {
      ...mapGetters('artworks', ['auctionsCatalog']),
      currentAuctionsCatalog() {
        return this.auctionsCatalog;
      },
      toggle: {
        get() {
          return STATUS_VALUES[this.auctionsCatalog.status];
        },
        set() {
          const currentStatus = this.auctionsCatalog.status;
          const newStatus = currentStatus === UNPUBLISHED ? PUBLISHED : UNPUBLISHED;
          this.toggleAuctionsCatalogStatus(newStatus);
        },
      },
      statusNoLack() {
        return !compareAuctionStatus(this.currentAuctionsCatalog, LACK);
      },
      auxiliaryPanelRoute() {
        return Routes.employees_auctions_catalog_auxiliary_path(this.currentAuctionsCatalog.id);
      },
      liveType() {
        return this.$route.params.auctionType === CATALOG_LIVE_TYPE;
      },
    },
    created() {
      this.getFinishedAuctionsCatalog([this.$route.params.auctionType, this.$route.params.id]);
    },
    methods: {
      ...mapActions('artworks', ['getFinishedAuctionsCatalog', 'putAuctionsCatalogStatus']),
      makeToggle(value) {
        this.toggle = value;
      },
      toggleAuctionsCatalogStatus(newStatus) {
        const isLegacyData = this.currentAuctionsCatalog.idFromLegacyDatabase !== null;
        const params = { auctions_catalog: { status: newStatus } };
        if (isLegacyData) {
          params.auctions_catalog.data_from_legacy_database = true;
        }
        this.putAuctionsCatalogStatus([this.$route.params.auctionType,
          this.currentAuctionsCatalog.id, params]);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/internet/auctions_catalog_header.vue?6ee9c683